// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-education-center__wrapper .article-education-center__list-item[data-v-47bb9edb]{margin-bottom:20px}.article-education-center__wrapper .article-education-center__list-item[data-v-47bb9edb]:last-child{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
